import React from 'react';
import ReactDOM from 'react-dom';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom';

import Home from './App';
import Framework from './Framework'
import './index.css';
import './config'

if(global.constants.isMobile){
  import('./App_mobile.css');
  import('./Trial_mobile.css')
}else {
  if(global.constants.channel==="mengduo")
  {
    import('./App_mengduo.css');
    import('./Trial_mengduo.css');
  }
  else{
    import('./App.css');
    import('./Trial.css');
  }
}



const Hompage = () => (
  <Router>
    <Switch>
      <Route exact path="/" component={Home}/>
      <Route path="/" component={Framework} >
       
      </Route>
    </Switch>
  </Router>
)

ReactDOM.render(<Hompage />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js